module.exports = __webpack_public_path__ + "static/media/29EUNOG15.3e8b4a9a.jpg";